// extracted by mini-css-extract-plugin
export default {"upload":"file-upload_upload__0so8l","iconPlus":"file-upload_iconPlus__tqLyx","iconLoading":"file-upload_iconLoading__QE-9b"};